"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = require("../../constants/theme");
var _excluded = ["children", "size", "variant", "type", "href", "showBorderAlways", "hideBorderOnFocus"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * If you use this component as a link and you notice that the hover border is taking up the whole width, just wrap it in a flex div
 *
 */
var TextButton = (0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    href = _ref.href,
    _ref$showBorderAlways = _ref.showBorderAlways,
    showBorderAlways = _ref$showBorderAlways === void 0 ? false : _ref$showBorderAlways,
    _ref$hideBorderOnFocu = _ref.hideBorderOnFocus,
    hideBorderOnFocus = _ref$hideBorderOnFocu === void 0 ? false : _ref$hideBorderOnFocu,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, Object.assign({}, props, {
    size: size,
    variant: variant,
    type: type,
    href: href,
    ref: ref,
    showBorderAlways: showBorderAlways,
    hideBorderOnFocus: hideBorderOnFocus
  }), /*#__PURE__*/_react["default"].createElement("span", null, children));
});
var _default = exports["default"] = TextButton;
var StyledButton = exports.StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "TextButton__StyledButton",
  componentId: "sc-1jj00yr-0"
})(["text-decoration:none;padding:0.4rem 0;", ";font-weight:500;text-align:left;--max-line:22;color:", ";> span{position:relative;align-items:center;display:flex;>:first-child +:last-child{margin-left:0.5em;}:after{position:absolute;content:'';left:0;bottom:0;right:0;opacity:0;border-bottom:1px solid currentColor;", ";}svg{margin-top:", ";}}", ";:focus{> span{::after{opacity:1;}}}:hover{> span{::after{opacity:1;}}color:", ";}:disabled{color:", ";cursor:not-allowed;}svg{flex-shrink:0;}"], function (_ref2) {
  var theme = _ref2.theme,
    size = _ref2.size;
  return (0, _theme.getFontCss)(theme.fontSizes.body[size]);
}, function (_ref3) {
  var theme = _ref3.theme,
    variant = _ref3.variant;
  return variant === 'danger' ? theme.colors.negative['60'] : (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.textAction);
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'tiny' ? 'padding-bottom: 2px;' : '';
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'tiny' ? '0' : '-2px';
}, function (_ref6) {
  var showBorderAlways = _ref6.showBorderAlways;
  return showBorderAlways && (0, _styledComponents.css)(["> span{::after{opacity:1;}}"]);
}, function (_ref7) {
  var theme = _ref7.theme,
    variant = _ref7.variant;
  return variant === 'danger' ? theme.colors.negative['70'] : (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.textAction, 1);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['40'];
});
//# sourceMappingURL=TextButton.js.map